export default __webpack_public_path__ + "static/blob-32-c03c917ca215bada87db1127b63e771e.svg";